import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actionTypes from './../../store/actions/clearButtonAction';
import fetchClearButtonAction from './../../store/actions/fetch/fetchClearButtonAction';
import Loader from './../../components/Loader/Loader';

import { RESET_PRODUCTS } from '../../store/actions/productsAction';
import { CLEAR_IMAGES } from '../../store/actions/pdfOutputAction';
import { DEFAULT as DEFAULT_GENDER } from '../../store/actions/genderAction';
import { DEFAULT as DEFAULT_ANIMAL_TYPE } from '../../store/actions/animalTypeAction';
import { DEFAULT as DEFAULT_WEIGHT_ADJUSTMENT } from '../../store/actions/weightAdjustmentAction';
import { DEFAULT as DEFAULT_MAIN_HEADING } from '../../store/actions/mainHeadingAction';
import { DEFAULT as DEFAULT_PHYSICAL_ACTIVITY } from '../../store/actions/physicalActivityAction';
import { DEFAULT as DEFAULT_DIET } from '../../store/actions/dietAction';
import { DEFAULT as DEFAULT_BODY_CONDITION } from '../../store/actions/bodyConditionAction';
import { DEFAULT as DEFAULT_CONDITION_SCORE } from '../../store/actions/conditionScoreAction';
import { DEFAULT as DEFAULT_FEEDING_GUIDELINES_PRODUCTS } from '../../store/actions/feedingGuidelinesProductsAction';
import { DEFAULT as DEFAULT_DIAGNOSES } from '../../store/actions/diagnosesAction';
import { DEFAULT as DEFAULT_BIRTHDATE } from '../../store/actions/birthDateAction';
import { DEFAULT as DEFAULT_BREED } from '../../store/actions/breedAction';
import { DEFAULT as DEFAULT_PET_INFO } from '../../store/actions/petInfoAction';
import { DEFAULT as DEFAULT_SIGNALMENT } from '../../store/actions/signalmentAction';
import { DEFAULT as DEFAULT_CRITICAL_CARE } from '../../store/actions/criticalCareAction';

/**
 * Clear form button component
 */
class ClearFormButton extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  handleClick = () => {
    const { clearForm } = this.props;
    clearForm();
  };

  render() {
    const { data, ready, pending, error, defaultValues } = this.props;

    if ( !ready && !error && !pending ) {
      defaultValues();
    }
    // If clear button data is pending
    if( pending || !ready ) return (
      <Loader/>
    );

    return (
      <>
        <label className='sr-only' htmlFor={data.label} hidden>
          {data.label}
        </label>
        <input
          type='button'
          onClick={ this.handleClick }
          className="nppe2-fc-clear-form-button"
          name={data.label}
          value={data.label}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.clearButtonReducer.error,
    data: state.clearButtonReducer.data,
    pending: state.clearButtonReducer.pending,
    ready: state.clearButtonReducer.ready,
  }
};

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(
    {
      fetchData: fetchClearButtonAction
    },
    dispatch,
  ),
  defaultValues: () => dispatch({
    type: actionTypes.DEFAULT,
  }),
  clearForm: () => {
    dispatch({ type: RESET_PRODUCTS });
    dispatch({ type: CLEAR_IMAGES });
    dispatch({ type: DEFAULT_GENDER });
    dispatch({ type: DEFAULT_ANIMAL_TYPE });
    dispatch({ type: DEFAULT_WEIGHT_ADJUSTMENT });
    dispatch({ type: DEFAULT_MAIN_HEADING });
    dispatch({ type: DEFAULT_PHYSICAL_ACTIVITY, selectedAnimalType: "dog"});
    dispatch({ type: DEFAULT_PET_INFO });
    dispatch({ type: DEFAULT_DIET });
    dispatch({ type: DEFAULT_BODY_CONDITION });
    dispatch({ type: DEFAULT_CONDITION_SCORE });
    dispatch({ type: DEFAULT_FEEDING_GUIDELINES_PRODUCTS });
    dispatch({ type: DEFAULT_DIAGNOSES });
    dispatch({ type: DEFAULT_BIRTHDATE });
    dispatch({ type: DEFAULT_BREED, selectedAnimalType: "dog" });
    dispatch({ type: DEFAULT_SIGNALMENT });
    dispatch({ type: DEFAULT_CRITICAL_CARE });
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ClearFormButton);
